import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { trackEvent, useParamsState } from '@/helpers'
import { ROUTES_ADMIN } from '@/router'
import { useSupplierDetail } from '@/services'
import { Button, ChevronLeftIcon, Text } from '@mercai/clever'

import { SupplierDrawerForm, SupplierForecastsTable } from '../../../components'

import { Metrics } from './components'

import { activeTabsItems, getTabsItems } from './show.constants'

import styles from './show.module.css'

export const SupplySupplierShow = () => {
  const { t } = useTranslation('screenSupplierShow')

  const { uuid } = useParams()

  const [queryParams, setQueryParams] = useParamsState({
    uuid: '',
    form: '',
    tab: 'all',
  })

  const { data } = useSupplierDetail(uuid)

  const onHandleEditRegister = (uuid: string) => {
    setQueryParams({ ...queryParams, form: 'true', uuid })
  }

  const tabsComponents: Record<string, React.ReactNode> = {
    metrics: (
      <div className={styles.metrics}>
        <Metrics values={data?.data} />
      </div>
    ),
    products: <SupplierForecastsTable supplierUuid={uuid || ''} isEditable />,
    quotations: <div>quotations</div>,
  }

  useEffect(() => {
    trackEvent('adminTransportSupplierShowPageView')
  }, [])

  return (
    <div>
      <section className={styles['header-section']}>
        <div className={styles['header-left-sidebar']}>
          <a href={`/${ROUTES_ADMIN.SUPPLY.SUPPLIERS.path}`}>
            <ChevronLeftIcon />
          </a>
          <div>
            <Text>
              <strong>{`${t('supplierTitle')} / `}</strong>
              <Text>{data?.data?.name}</Text>
            </Text>
            <div className={styles.title}>
              <Text variant="title-large">{data?.data?.name}</Text>
            </div>
          </div>
        </div>
        <Button onClick={() => onHandleEditRegister(uuid || '')}>
          {t('supplierEdit')}
        </Button>
      </section>

      <div className={styles.content}>
        <section className={styles['tab-filter']}>
          {getTabsItems(t).map((tabItem) => (
            <Button
              model="pill"
              variant={
                queryParams.tab === tabItem.key ? 'primary' : 'secondary'
              }
              key={tabItem.key}
              onClick={() =>
                setQueryParams({ ...queryParams, tab: tabItem.key })
              }
            >
              {tabItem.title}
            </Button>
          ))}
        </section>
        <section>
          {activeTabsItems?.[queryParams?.tab || 'all']?.map(
            (tab) => tabsComponents?.[tab],
          )}
        </section>
      </div>

      <SupplierDrawerForm
        isOpen={!!queryParams.form}
        onHandleOpen={() =>
          setQueryParams({ ...queryParams, form: '', uuid: '' })
        }
        supplierUuid={queryParams.uuid}
      />
    </div>
  )
}
